import {socialAuthIntegrationSchema} from '@practicegenius/domain/src/data/integrations';
import {z} from 'zod';
import {resolveRoute} from '@practicegenius/pg-util/src/UrlUtils';
import {idDotLoginRoutes} from './sharedRoutes';

// @see apps/api-core.patientrewardshub.com/globaluser/Http/Controllers/Social/AuthController.php handleProviderCallback $redirectUrl
export const socialProviderCallbackParamsSchema = z.object({
  provider: socialAuthIntegrationSchema,
  code: z.string().optional(),
  token: z.string().optional(),
});

type SocialProviderCallbackQueryParams = z.infer<
  typeof socialProviderCallbackParamsSchema
>;

export const buildSocialProviderCallbackLink = (
  params: SocialProviderCallbackQueryParams,
) => `${idDotLoginRoutes.social.callback}?${new URLSearchParams(params)}`;

export const socialProviderLoginParamsSchema = z.object({
  provider: socialAuthIntegrationSchema,
});

type SocialProviderLoginParams = z.infer<
  typeof socialProviderLoginParamsSchema
>;

export const buildSocialProviderLoginLink = (
  params: SocialProviderLoginParams,
) => resolveRoute(idDotLoginRoutes.social.login, params);
